import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.965 8.03C7.246 9.062 6 10.849 6 13c0 3.261 2.739 6 6 6s6-2.739 6-6c0-2.172-1.268-3.974-3.015-5M12 5v8"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);
